<template>
	<div class="o-container o-container--thin onboarding-page">
		<onboarding-form :user="user" />
	</div>
</template>

<script>
    import OnboardingForm from '../forms/OnboardingForm.vue';
    import { mapState } from 'vuex';

    export default {
        components: {
            OnboardingForm
        },
		computed: {
            ...mapState('user', {
                user: state => state.user
            })
		}
    }
</script>
